import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, useRouter } from '@tanstack/react-router'

interface RouterContext {
  queryClient: QueryClient
}

function RootErrorComponent({ error }: { error: Error }) {
  const router = useRouter()
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50">
      <div className="max-w-md text-center flex flex-col gap-4">
        <h1 className="font-serif text-2xl text-warm-gray-900">Something went wrong</h1>
        <p className="text-sm text-warm-gray-400">{error.message}</p>
        <button
          type="button"
          onClick={() => router.invalidate()}
          className="text-sm text-terracotta-500 hover:text-terracotta-600"
        >
          Try again
        </button>
      </div>
    </div>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  errorComponent: RootErrorComponent,
})
